import React, { useContext, RefCallback } from 'react';
import HeaderContext from './HeaderContext';

interface HeaderTitleProps {
    className?: string;
}

const PageTitleContainer: React.FC<HeaderTitleProps> = ({ className }) => {
    const context = useContext(HeaderContext);

    const updateRef: RefCallback<HTMLDivElement> = (ref) => {
        if (ref && context.container) {
            ref.appendChild(context.container);
        }
    };

    return <div className={className} ref={updateRef}></div>;
};

export default PageTitleContainer;
